import {React, Component, Container, _, Icon} from 'utils';
import { CampaignStore, Campaigns, Creators } from 'model';

class CreateForUser extends Component {

	handleSave = (event) => {

		event.preventDefault();

		var params = {
			id: this.state.id,
			companyId: this.state.companyId
		};
		var selected = Campaigns.getState().selected;

		Creators.mapForUser(selected, params);
	}

	static getStores() {
		return [CampaignStore];
	}

	static calculateState(state, props) {
		var state = CampaignStore.getState();

		return {
			id: state.id,
			companyId: state.companyId,
			created: state.created
		}
	}
	handleChangeId(event) {
		Creators.createIdForUser(event.target.value);
	}
	handleChangeCompanyId(event) {
		Creators.createCompanyIdForUser(event.target.value);
	}

	render() {
		var { id, companyId, created } = this.state;
			let errorContainer = null;

		const mystyle = {
			"padding":"10px",
			"marginBottom":"10px",
			"borderRadius":"5px"
		};

			if(created){
				errorContainer = <div className='alert-danger' style={mystyle}>
					<Icon name='' /> <span>{_('Pogreška u spremanju')}</span>
				</div>
			}
			return <div>
				<form className="form-horizontal" onSubmit={this.handleSave}>
					{errorContainer}
					<div className="form-group">
						<div className="col-md-12">
							<input type="text" className="form-control" value={id} placeholder={_('Unesi id korisnika')} onChange={this.handleChangeId} />
						</div>
					</div>
					<div className="form-group">
						<div className="col-md-12">
							<input type="text" className="form-control" value={companyId} placeholder={_('Unesi id tvrtke')} onChange={this.handleChangeCompanyId} />
						</div>
					</div>

					<div className="text-right">
						<input type="submit" className="btn btn-danger btn-block" value={_('Prebaci')} />
					</div>
				</form>
			</div>;


	}
}

const container = Container.create(CreateForUser, { withProps: true });
export default container;


// WEBPACK FOOTER //
// ./src/modules/campaign/CreateForUser.js